import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Montserrat';
  display: flex;
  flex-direction: column;
  width: 33.5rem;
  height: fit-content;
  background-color: ${({ theme: { colors } }) => colors.white};
  box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.15),
    0.2rem 0.4rem 0.6rem rgba(0, 0, 0, 0.15);
  border: 0.1rem solid initial;
  border-radius: 0.2rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 6.8rem;
  padding: 0 1.6rem;
  background-color: ${({ theme: { colors } }) => colors.b2cDarkWhite};
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cDarkWhite};
`;

export const LoaderContainer = styled.div`
  height: 40rem;
  width: 100%;
`;

export const ClassContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 8rem;
`;

export const BookingSummaryCategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.6rem;
  padding-bottom: 0.6rem;
`;

export const CenteredWrapper = styled.div<{ leftPadding?: boolean }>`
  align-self: center;
  padding-left: ${({ leftPadding }) => (leftPadding ? '1.6rem' : '0')};
`;

export const HeaderText = styled.span`
  font-weight: 400;
  font-size: 1.28rem;
  line-height: 1.6rem;
  text-transform: uppercase;
`;

export const LogoContainer = styled.div`
  width: 8rem;
  svg {
    height: 4rem;
  }
  align-self: center;
`;

export const BookingRef = styled(HeaderText)`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2rem;
`;

export const ClassSpan = BookingRef;
export const ClassImageWrapper = styled(CenteredWrapper)`
  height: 100%;
  padding-right: 1.6rem;
`;
export const ClassImage = styled.img`
  height: 100%;
`;

export const Line = styled.hr`
  border: none;
  width: 100%;
  margin: 0;
  border-bottom: 0.1rem solid ${({ theme: { colors } }) => colors.b2cLightGrey};
`;

export const DashLine = styled(Line)`
  border-bottom: 0.1rem dotted ${({ theme: { colors } }) => colors.b2cLightGrey};
`;
